import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { MODEL_PORTFOLIO } from 'Angular/constants/core.constants';
import { ABSOLUTE_ATTRIBUTION_PERIODICITY_OPTIONS } from 'SecuritiesApp/ts/constants/attribution.constants';
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { isPeriodicityDisabled } from 'SecuritiesApp/ts/features/attribution-relative/utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i6 from "../../../module-upsell/module-upsell.component";
import * as i7 from "../gain-loss-chart/gain-loss-chart.component";
const _c0 = a0 => ({ "text-gray-60": a0 });
function AttributionAbsoluteChartComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 15);
    i0.ɵɵlistener("click", function AttributionAbsoluteChartComponent_ng_container_10_Template_a_click_2_listener() { const periodicityOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updatePeriodicity(periodicityOption_r4.value)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const periodicityOption_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("chart-control-item ", periodicityOption_r4.value === ctx_r4.performancePeriodicity ? "current" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", periodicityOption_r4.disabled)("ngClass", i0.ɵɵpureFunction1(6, _c0, periodicityOption_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(periodicityOption_r4.label);
} }
export class AttributionAbsoluteChartComponent {
    constructor(eltRef, accountsService, securitiesService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.securitiesService = securitiesService;
        this.performancePeriodicityChange = new EventEmitter();
        this.periodicityOptions = cloneDeep(ABSOLUTE_ATTRIBUTION_PERIODICITY_OPTIONS);
    }
    ngOnChanges(changes) {
        if (changes.asOfDate?.currentValue) {
            this.periodicityOptions.forEach((periodicity) => {
                // eslint-disable-next-line no-param-reassign
                periodicity.disabled = isPeriodicityDisabled(periodicity.value, changes.asOfDate.currentValue);
            });
        }
        this.footnote = 'Points contributed to the overall return are estimates.';
        if (this.performancePeriodicity === PerformancePeriodicity.MAX) {
            if (this.securityType === MODEL_PORTFOLIO) {
                this.footnote += " Max timeframe uses the portfolio's inception date.";
            }
            else {
                this.footnote += " Max timeframe uses the security's earliest performance date.";
            }
        }
    }
    updatePeriodicity(performancePeriodicity) {
        const periodicityChanged = this.performancePeriodicity !== performancePeriodicity;
        if (periodicityChanged) {
            this.performancePeriodicity = performancePeriodicity;
            const preferenceName = `${this.securityType}_attribution_absolute_tab_zoom`;
            this.performancePeriodicityChange.emit(performancePeriodicity);
            this.accountsService.putUserPreferences({ [preferenceName]: performancePeriodicity }).subscribe();
        }
    }
}
AttributionAbsoluteChartComponent.ɵfac = function AttributionAbsoluteChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionAbsoluteChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
AttributionAbsoluteChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionAbsoluteChartComponent, selectors: [["ycn-attribution-absolute-chart"]], inputs: { performancePeriodicity: "performancePeriodicity", securityId: "securityId", securityType: "securityType", asOfDateCustom: "asOfDateCustom", asOfDate: "asOfDate", holdingsLayer: "holdingsLayer" }, outputs: { performancePeriodicityChange: "performancePeriodicityChange" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 9, consts: [["contributorsDetractorsHelpModal", ""], [1, "panel", "panel-data", "panel-stocks"], [1, "panel-header"], [1, "panel-title"], [1, "help-toggler", 3, "click"], [1, "panel-content"], [3, "title"], [1, "mb-1"], [1, "chart-control", "chart-control-compact", "border-0"], [4, "ngFor", "ngForOf"], [1, "divider-horizontal"], [3, "performancePeriodicity", "securityId", "securityType", "holdingsLayer", "asOfDateCustom", "asOfDate"], [1, "stocks-footer", "panel-date", "mb-1"], [1, "stock-label"], [1, "text-gray-50", 3, "textContent"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "chart-control-link", 3, "click", "disabled", "ngClass"]], template: function AttributionAbsoluteChartComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3", 3);
        i0.ɵɵtext(3, "Attribution\u00A0 ");
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function AttributionAbsoluteChartComponent_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r1); const contributorsDetractorsHelpModal_r2 = i0.ɵɵreference(18); return i0.ɵɵresetView(contributorsDetractorsHelpModal_r2.openModal("attribution_contributors_detractors")); });
        i0.ɵɵtext(5, " (?)");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelement(7, "ycn-module-upsell", 6);
        i0.ɵɵelementStart(8, "div", 7)(9, "ul", 8);
        i0.ɵɵtemplate(10, AttributionAbsoluteChartComponent_ng_container_10_Template, 4, 8, "ng-container", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "div", 10)(12, "ycn-gain-loss-chart", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 12)(14, "div", 13);
        i0.ɵɵtext(15, "#");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "span", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(17, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("title", "Attribution");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.periodicityOptions);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("performancePeriodicity", ctx.performancePeriodicity)("securityId", ctx.securityId)("securityType", ctx.securityType)("holdingsLayer", ctx.holdingsLayer)("asOfDateCustom", ctx.asOfDateCustom)("asOfDate", ctx.asOfDate);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("textContent", ctx.footnote);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i4.DisabledDirective, i5.HelpModalComponent, i6.ModuleUpsellComponent, i7.GainLossChartComponent], encapsulation: 2 });
